// libraries
import { useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import firebase from "../firebase/firebase";
import { useToasts } from "react-toast-notifications";

// context
import RecipesContext from "../context/recipes";
import UserContext from "../context/user";

// assets
// import bg from "../assets/image_3.jpg";

// helpers
import { getSingleRecipe } from "../utils/helpers";

// components
import Loading from "../components/Loading";
import Hero from "../components/Hero";
import RecipeDetailsComponent from "../components/RecipeDetails/RecipeDetailsComponent";
import Newsletter from "../components/Newsletter";
// import RelatedProducts from "../components/Product/RelatedProducts";

// firestore
const favoritesDocument = firebase.firestore().collection("users");

const RecipeDetails = () => {
  // use params
  const { id } = useParams();

  // use context
  const { recipes, loading, setLoading } = useContext(RecipesContext);
  const { user } = useContext(UserContext);

  const [fav, setFav] = useState(false);

  // use toast
  const { addToast } = useToasts();

  var singleRecipe = getSingleRecipe(recipes, id);

  useEffect(() => {
    if (user) {
      setLoading(true);
      favoritesDocument
        .doc(user.uid)
        .collection("favorites")
        .onSnapshot((snapshot) => {
          snapshot.docs.map((doc) => doc.data().id === id && setFav(true));
          setLoading(false);
        });
    }
  }, [user]);

  const addToFavorites = async () => {
    if (user) {
      setLoading(true);
      await favoritesDocument
        .doc(user.uid)
        .collection("favorites")
        .doc(id)
        .set({
          title: singleRecipe.recipe,
          id,
          category: singleRecipe.category,
          image: singleRecipe.image,
          meal: singleRecipe.meal,
        })
        .then(() => {
          addToast("Recipe added to Favorites!", {
            appearance: "success",
          });
          setLoading(false);
          setFav(true);
        })
        .catch((e) => {
          addToast("Couldnt't add recipe to favorites! Please try again.", {
            appearance: "error",
          });
          setLoading(false);
        });
    } else {
      addToast("Please login first!", {
        appearance: "error",
      });
    }
  };

  const deleteFavorite = async () => {
    if (user) {
      setLoading(true);
      await favoritesDocument
        .doc(user.uid)
        .collection("favorites")
        .doc(id)
        .delete()
        .then(() => {
          addToast("Recipe removed from Favorites!", {
            appearance: "info",
          });
          setLoading(false);
          setFav(false);
        })
        .catch((e) => {
          addToast(
            "Couldnt't remove recipe from favorites! Please try again.",
            {
              appearance: "error",
            },
          );
          setLoading(false);
        });
    } else {
      addToast("Please login first!", {
        appearance: "error",
      });
    }
  };

  if (loading && recipes.length === 0) {
    return (
      <div className='loading-wrapper'>
        <Loading />
      </div>
    );
  } else {
    return (
      <>
        <Hero
          // image={bg}
          title='Recipes'
          breadName={singleRecipe && singleRecipe.recipe}
          singleProduct={true}
        />
        <RecipeDetailsComponent
          product={singleRecipe && singleRecipe}
          fav={fav}
          addToFavorites={addToFavorites}
          deleteFavorite={deleteFavorite}
        />
        {/*   <RelatedProducts /> */}
        <Newsletter />
      </>
    );
  }
};

export default RecipeDetails;
